import './iechecker.js'

if (navigator.userAgent.indexOf('MSIE') !== -1) {
    // eslint-disable-next-line no-console
    console.error = function (message) {
        throw new Error(message)
    }

    // eslint-disable-next-line no-console
    console.error('Unsupported browser')
}

import React from 'react'
import ReactDOM from 'react-dom'
import { ApolloProvider } from 'react-apollo'

/**
 * react-datepicker since version 2.0.0 replaced moment.js with date-fns and therefore
 * we need to localize it. date-fns is not listed in package.json but is a dependency of react-datepicker
 * so it's available as long as react-datepicker is available. And it's not used for anything else anyway.
 *
 * Update: Not longer used due to used format "L". Will keep it here once we need to localize it based on current language.
 */
// import { registerLocale, setDefaultLocale } from 'react-datepicker'
// import csLocale from 'date-fns/locale/cs'
// registerLocale('cs', csLocale)
// setDefaultLocale('cs')

import Root from './router'
import store from './admin/store'
import { Provider } from 'react-redux'
import TagManager from 'react-gtm-module'

import history from './history'
import { sentryInit } from './components/logger/sentry'

import { initAWS } from './components/aws/initializer'
import {
    initFirebase,
    initFirestore,
} from './components/firebase/initializer'
import { initApiChecker } from './components/api-checker/checker'

const {
    REACT_APP_GOOGLE_TAG_MANAGER: tagManagerId,
    REACT_APP_LOG_LEVEL: logLevel,
} = window.APP_CONFIG

if (tagManagerId) {
    const tagManagerArgs = {
        gtmId: tagManagerId,
    }

    TagManager.initialize(tagManagerArgs)
}

sentryInit(history)

initFirebase()
initFirestore()
initApiChecker()

if (logLevel) {
    window.LOG_LEVEL = logLevel
}

/** @namespace moment.tz */
const render = client => {
    ReactDOM.render(
        <ApolloProvider client={client}>
            <Provider store={store}>
                <Root history={history} />
            </Provider>
        </ApolloProvider>,
        document.getElementById('app')
    )
}

initAWS()
    .then(client => render(client))
